import React from "react";
import { Calendar } from "primereact/calendar";
import styles from "./index.module.css"; 

const renderCalendar = (
    label: string,
    onChange: (e: any) => void,
    value: any,
    isDisabled = false, 
    key?: string,
    showTime?: boolean
): JSX.Element => (
    <div className={styles.filterItem}>
        <label className={styles.filterLabel}>{label} :</label>
        <Calendar
            showTime={showTime !== null ? showTime : true}
            placeholder="Selecione"
            value={value}
            onChange={onChange}
            className={`${styles.dropdown} ${styles.calendar}`}
            disabled={isDisabled} 
            key={key} 
            dateFormat="dd/mm/yy"
        />
    </div>
);
export default renderCalendar;
